import { useIntl } from "react-intl";

import { useCohort } from "@/components/user-context";

import { SignupDefault } from "../../../components";
import {
    LoggedInBlueWaveTemplateJsmExistingUser,
    LoggedInBlueWaveTemplateJsmNewUser
} from "../../components";

export const LoggedInJsmStandard = () => {
    const { formatMessage } = useIntl();
    const cohort = useCohort();

    if (cohort === "new-user") {
        return (
            <LoggedInBlueWaveTemplateJsmNewUser
                productEditionText={formatMessage({
                    id: "WacSignupHeader.cloudStandard",
                    defaultMessage: "Cloud Standard"
                })}
            />
        );
    }

    if (cohort) {
        return (
            <LoggedInBlueWaveTemplateJsmExistingUser
                productEditionText={formatMessage({
                    id: "WacSignupHeader.cloudStandard",
                    defaultMessage: "Cloud Standard"
                })}
            />
        );
    }

    if (cohort) {
        // bxpkit catch-all leaving in for possible restart of experiment: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/signup_trialing_add_payment_ab/results can remove ~July 18th
        return <SignupDefault />;
    }

    return null;
};
